export default "__VITE_ASSET__DTX_Kv6R__"